// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const DispatchSetCanSubmitOrder: Handler = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/SetCanSubmitOrder",
    });
};

export const chain = [DispatchSetCanSubmitOrder];

const setCanSubmitOrder = createHandlerChainRunner(chain, "SetCanSubmitOrder");
export default setCanSubmitOrder;
